import React from 'react';
import {
  Alert,
  Box,
  Button,
  Chip,
  Paper,
  Stack,
  Typography,
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import BuySellStageDonut from './BuySellStageDonut.jsx';
import BuySellMetricCard from './BuySellMetricCard.jsx';

const BuySellsDashboard = ({
  rows,
  tableRows,
  metrics,
  stageFilter,
  onStageFilterChange,
  onClearFilter,
  onAdd,
  columns,
  loading,
  errorMessage,
  showWipBadge = false,
}) => (
  <Stack spacing={2.5}>
    <Box>
      {showWipBadge && <Chip label="WIP" size="small" color="warning" sx={{ mb: 1 }} />}
      <Typography variant="h4" sx={{ fontWeight: 700 }}>
        Buy/Sells Dashboard
      </Typography>
      <Typography sx={{ color: 'text.secondary', mt: 0.75 }}>
        Track buy/sell stages, DAF uploads, and alert actions.
      </Typography>
    </Box>

    {errorMessage && (
      <Alert severity="error" variant="outlined">
        {errorMessage}
      </Alert>
    )}

    <Box>
      <BuySellStageDonut rows={rows} onLegendClick={onStageFilterChange} />
      {stageFilter && (
        <Stack direction="row" spacing={1} sx={{ mt: 1, alignItems: 'center' }}>
          <Chip label={`Filtered: ${stageFilter}`} variant="outlined" />
          <Button size="small" onClick={onClearFilter}>
            Clear filter
          </Button>
        </Stack>
      )}
    </Box>

    <Stack direction={{ xs: 'column', md: 'row' }} spacing={2}>
      <BuySellMetricCard
        label="Total buy/sells"
        value={metrics.total}
        helper="All tracked buy/sell accounts."
      />
      <BuySellMetricCard
        label="DAF pending"
        value={metrics.dafPending}
        helper="DAF stage items needing attention."
      />
    </Stack>

    <Paper variant="outlined" sx={{ p: 2 }}>
      <Stack
        direction={{ xs: 'column', sm: 'row' }}
        spacing={1.5}
        sx={{ mb: 1.5, justifyContent: 'space-between' }}
      >
        <Box>
          <Typography variant="h6" sx={{ fontWeight: 600 }}>
            Buy/Sell accounts
          </Typography>
          <Typography variant="body2" sx={{ color: 'text.secondary' }}>
            Salesforce accounts flagged for buy/sell workflows.
          </Typography>
        </Box>
        <Box>
          <Button startIcon={<AddIcon />} variant="contained" onClick={onAdd}>
            Add new buy/sell
          </Button>
        </Box>
      </Stack>
      <Box sx={{ height: 520, width: '100%' }}>
        <DataGrid
          rows={tableRows || rows}
          columns={columns}
          loading={loading}
          disableRowSelectionOnClick
          pageSizeOptions={[10, 25, 50]}
          initialState={{
            pagination: { paginationModel: { pageSize: 10, page: 0 } },
            sorting: { sortModel: [{ field: 'stageDate', sort: 'desc' }] },
          }}
          slots={{ toolbar: GridToolbar }}
          slotProps={{
            toolbar: {
              showQuickFilter: true,
              quickFilterProps: { debounceMs: 250 },
            },
          }}
        />
      </Box>
    </Paper>
  </Stack>
);

export default BuySellsDashboard;
